import { render, staticRenderFns } from "./Domicilio.vue?vue&type=template&id=583fb52e"
import script from "./Domicilio.vue?vue&type=script&lang=js"
export * from "./Domicilio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('583fb52e')) {
      api.createRecord('583fb52e', component.options)
    } else {
      api.reload('583fb52e', component.options)
    }
    module.hot.accept("./Domicilio.vue?vue&type=template&id=583fb52e", function () {
      api.rerender('583fb52e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/Domicilio.vue"
export default component.exports